import { Widget } from '../../../../../../../providers/bridge-api/dashboard.service';
import { FieldService } from '../../../../../../../providers/storage-api/field.service';
import { Utils } from '../../../../../../../utils/utils';
import { WidgetChartOptions } from '../../../../widget-chart/widget-chart.component';
import { AiSummaryTranslocoParameters } from './widget-ai-insights-summary.service';

export default class GaugeSummaryParameters implements AiSummaryTranslocoParameters {
  assembleParameters(selectedPoints: any[], widget: Widget<WidgetChartOptions>) {
    const gaugeOptions = widget.payload.gaugeOptions;
    let translationPrefix = `widgets.ai-insights.summary.${widget.payload.type}.${gaugeOptions.metric}`;

    let boxSize;
    if (gaugeOptions.metric === 'box') {
      translationPrefix = `${translationPrefix}.${gaugeOptions.metricBoxType}`;
      boxSize = gaugeOptions.metricBoxSize;
    }

    return selectedPoints.map((p, idx) => {
      let translationKey = `${translationPrefix}.${idx === 0 ? 'first-point' : 'rest-of-points'}`;

      if (idx === 0) {
        translationKey = `${translationKey}.${p.series.name ? 'has-comparison' : 'no-comparison'}`;
      }

      return {
        translationKey,
        translationParams: {
          boxSize,
          fieldName: FieldService.getFieldLongName(widget.payload.analyticItem),
          fieldValue: p.series.name,
          score: Utils.round(p.y),
        },
      };
    });
  }
}
